import { useEffect, useState } from "react";
import LogResponse from "../../../../components/Admin/Processes/ETL-Process-Log/LogTable/LogResponse";
import { useLocation, useSearchParams } from "react-router-dom";
import store from "../../../../store";
import { setIsLoading } from "../../../../features/userSlice";
import { ETLLogsEndPointLogic } from "../../../../logic/Admin/ETLChains/ETLLogsEndPointLogic";
import SimpleBackdrop from "../../../../components/BackDrop/BackDrop";

export default function ETLLogLogResponseScreen(userToken: any) {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [error, setError] = useState("") as any;
  const [loading, setLoading] = useState(false);
  const token = userToken?.userToken;
  const runIdFromURL = searchParams.get("response_run_id");
  const [singleLog, setSingleLog] = useState([]);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    const fetchSingleLogs = async () => {
      try {
        // Check if the user has permissions and either runId or runIdFromURL is available
        if (location.state?.runId || runIdFromURL) {
          store.dispatch(setIsLoading(true));
          setLoading(true);
          const runId = location.state?.runId || runIdFromURL; // Use whichever is available
          await ETLLogsEndPointLogic.getLogsById(token, runId, setSingleLog);
        } else {
          setError("User does not have permission");
        }
      } catch (error) {
        setError("Something went wrong while getting logs");
      } finally {
        store.dispatch(setIsLoading(false));
        setLoading(false);
        setRefresh(false);
      }
    };

    // Call fetchSingleLogs if userToken is available and either runId or runIdFromURL is present
    if (userToken && (location.state?.runId || runIdFromURL)) {
      setRefresh(false);
      fetchSingleLogs();
    }
  }, [token, userToken, location.state, runIdFromURL, refresh]);

  return (
    <div>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <LogResponse
          singleLog={singleLog}
          error={error}
          setRefresh={setRefresh}
          token={token}
        />
      )}
    </div>
  );
}
